import { configureStore } from "@reduxjs/toolkit";
import FormSliceReducer from "./slices/form.slice";

const FormStore = configureStore({
  reducer: {
    form: FormSliceReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof FormStore.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof FormStore.dispatch;

export default FormStore;
